// extracted by mini-css-extract-plugin
export default {"root":"gml3QCgKyon4IYZeY1pK","close":"f8TMolaqwoIrjsNtgoOG"};